import { DateTime } from 'luxon';

import { isWithinThresholdFromNow } from 'utils';
import { getInternetValueAndUnit } from 'utils/accumulators/convertAccumulators';

export const getRestTime = (tetheringProExpiration: Date | string) => {
  const now = DateTime.local();
  const timeLocal = getDateTimeLocal(tetheringProExpiration);

  const diff = timeLocal.diff(now, ['hours', 'minutes']);
  const totalMinutes = Math.floor(diff.as('minutes'));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const restTime = hours === 0 ? `${minutes} мин` : `${hours} ч`;

  return `ещё ${restTime} быстрой раздачи`;
};

const getDateTimeLocal = (date: Date | string) => {
  return DateTime.fromISO(typeof date === 'string' ? date : date.toISOString(), {
    zone: 'utc',
  }).toLocal();
};

const getFormattedEndDateTime = (expirationDate: Date | string) => {
  if (!expirationDate) {
    return '';
  }
  const timeLocal = getDateTimeLocal(expirationDate);
  return timeLocal.setLocale('ru').toFormat('d MMMM, HH:mm');
};

export const getTextForUnlimitedForDay = (expirationDate?: string) => {
  return expirationDate && `до ${getFormattedEndDateTime(expirationDate)}`;
};

export const getTextColorForUnlimitedForDay = (expirationDate?: string): 'error' | 'secondary' => {
  if (!expirationDate) {
    return 'secondary';
  }

  return isWithinThresholdFromNow({ dateString: expirationDate, threshold: { minute: 15 } }) ?
      'error'
    : 'secondary';
};

export const getTextForUnlimitedWithLimitedTethering = ({
  rest,
  size,
}: {
  rest: number;
  size: number;
}) => {
  const tetheringRest = getInternetValueAndUnit(rest)?.rest;
  const { rest: tetheringSize, unit } = getInternetValueAndUnit(size) ?? {};
  return `${parseFloat(tetheringRest)?.toLocaleString('ru-RU')?.replace('.', ',')} из ${parseFloat(tetheringSize)?.toLocaleString('ru-RU')?.replace('.', ',')} ${unit?.toLowerCase()}`;
};

export const getMainTextForUnlimitedTethering = ({
  tetheringIsLow,
  tetheringProMode,
  tetheringExpiration,
}: {
  tetheringExpiration?: string;
  tetheringIsLow: boolean;
  tetheringProMode?: string;
}) => {
  if (!tetheringProMode && tetheringIsLow) {
    return 'до 1 мбит/с';
  }

  if (tetheringProMode === 'month') {
    return 'max скорость раздачи';
  }

  if (tetheringProMode === 'day' && tetheringExpiration) {
    return getRestTime(tetheringExpiration);
  }

  return '';
};

export const getSecondaryTextForUnlimitedTethering = ({
  tetheringIsLow,
  tetheringProMode,
}: {
  tetheringIsLow?: boolean;
  tetheringProMode?: string;
}) => {
  return !tetheringProMode && tetheringIsLow ? 'на раздачу' : undefined;
};

export const getTextValueWithRest = (rest: number) => {
  return `${rest?.toLocaleString('ru-RU')?.replace('.', ',')}`;
};
